import styled from "@emotion/styled";
import { PureComponent } from "react";

import { CustomerDetailsTooltip } from "components/customer-details";
import { isURLWithProtocol } from "helpers/validate";

import { LinkEllipsisContainer, LinkEllipsisStyles } from "./LinkEllipsis";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const isValidUrl = (url: string) => {
  if (typeof url !== "string") {
    return false;
  }
  const hasProtocol = url.startsWith("http://") || url.startsWith("https://");
  return isURLWithProtocol(url) && hasProtocol;
};

interface IProps {
  inline?: boolean;
  target?: string;
  className?: string;
  url: string;
  value?: string;
  onClick?(): void;
}

const Container = styled.div<{ inline: boolean }>`
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.inline ? "inline-block" : "block")
  };
  position: relative;
  background-color: white;
  margin-bottom: 8px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  line-height: 20px;
  max-width: 100%;
`;

const Value = styled.span`
  word-break: break-all;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;
interface IState {
  isVisible: boolean;
}
export class Link extends PureComponent<IProps, IState> {
  state = { isVisible: false };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleMouseLeave = () => {
    this.setState({ isVisible: false });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleMouseEnter = () => {
    this.setState({ isVisible: true });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private renderLink = () => (
    <a
      href={this.props.url}
      target={this.props.target || "_self"}
      rel="noopener noreferrer"
      onClick={this.props.onClick}
      onMouseEnter={this.handleMouseEnter}
      onMouseLeave={this.handleMouseLeave}
    >
      {this.props.value}
    </a>
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private renderLinkWithTooltip = () => (
    <CustomerDetailsTooltip isVisible={this.state.isVisible} tooltipContent={this.props.url}>
      <div css={LinkEllipsisContainer}>
        <a
          href={this.props.url}
          target={this.props.target || "_self"}
          rel="noopener noreferrer"
          onClick={this.props.onClick}
          css={LinkEllipsisStyles}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {this.props.url}
        </a>
      </div>
    </CustomerDetailsTooltip>
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private renderInvalidLink = () => (
    // @ts-expect-error TS(2322)
    <Container inline={this.props.inline} className={this.props.className}>
      <Value>{this.props.url}</Value>
    </Container>
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { inline = true, className, url, value } = this.props;
    if (!isValidUrl(url)) {
      return this.renderInvalidLink();
    }

    return (
      <Container inline={inline} className={className}>
        {value ? this.renderLink() : this.renderLinkWithTooltip()}
      </Container>
    );
  }
}
